import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Space from 'src/components/atoms/Space'
import Text from 'src/components/atoms/TextNew'
import View from 'src/components/atoms/View'
import RightArrowSvg from 'src/components/other/svg/RightArrowSvg'
import ThankYouBuyNowSvg from 'src/components/other/svg/ThankYouBuyNowSvg'

const ThankYouBuyNowModalContent = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <View className="flex flex-col items-center px-5 h-full">
      <Space y={30} />
      <Text className="text-xl text-white text-center font-SemiBold max-w-[400px] mx-auto">
        {t('buy_now_modal.you_offer_has_been_sent')}
      </Text>
      <Space y={10} />
      <View className="min-w-[200px] flex justify-center items-center text-center">
        <ThankYouBuyNowSvg className="w-[84px] h-[78px]  text-white" />
      </View>
      <View className="flex-1" />
      <View className="flex flex-col justify-center items-center gap-2">
        <>
          <View
            className="flex relative top-1 gap-3 justify-center items-center text-white font-SemiBold cursor-pointer"
            onClick={() => {
              navigate('/purchasing/realization')
            }}>
            <>{t('buy_now_modal.realization')}</>
            <RightArrowSvg className="w-6 h-6 text-white" />
          </View>
          <Text className="text-white text-l relative top-4 text-center">
            <>{t('buy_now_modal.go_to_realization')}</>
          </Text>
        </>
      </View>
      <Space y={10} />
    </View>
  )
}

export default ThankYouBuyNowModalContent
